import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminCompanies = lazy(() => import("@/pages/admin/AdminCompanies"));

export const Route = createFileRoute("/admin/elhandelsbolag")({
  component: () => <AdminCompanies />,
});
